import React from 'react'
import machine from "../../imagens/machine/machine.png"
import machine2 from "../../imagens/machine/machine2.png"
import machine3 from "../../imagens/machine/machine3.png"
import machine4 from "../../imagens/machine/machine4.png"
import machine5 from "../../imagens/machine/machine5.png"
import machine6 from "../../imagens/machine/machine6.png"
import machine7 from "../../imagens/machine/machine7.png"
import machine8 from "../../imagens/machine/machine8.png"
import machine9 from "../../imagens/machine/machine9.png"
import machine10 from "../../imagens/machine/machine10.png"
import machine11 from "../../imagens/machine/machine11.png"
import machine12 from "../../imagens/machine/machine12.png"
import machine13 from "../../imagens/machine/machine13.JPG"
import machine14 from "../../imagens/machine/machine14.JPG"
import machine15 from "../../imagens/machine/machine15.JPG"

import Header from "../../Components/Header"
import Equipments from '../../Components/machineCapabilities'


const listaMachine = [
    {
        img: machine
    },
    {
        img: machine2
    },
    {
        img: machine3
    },
    {
        img: machine4
    },
    {
        img: machine11
    },
    {
        img: machine5
    },
    {
        img: machine6
    },
    {
        img: machine7
    },
    {
        img: machine8
    },
    {
        img: machine9
    },
    {
        img: machine10
    },
    {
        img: machine12
    },
    {
        img: machine13
    },
    {
        img: machine14
    },
    {
        img: machine15
    },

]



function EquipmentsPage() {
    return (
        <div>
            <Header />

                <Equipments
                    listaMachine={listaMachine}
                >
                </Equipments>
            </div>
    )
}

export default EquipmentsPage